import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";
import healthcareImg from "@/assets/healthcare-ai.jpg";
import tradesImg from "@/assets/trades-ai.jpg";
import businessImg from "@/assets/business-ai.jpg";
import logisticsImg from "@/assets/logistics-ai.jpg";

const IndustryTabs = () => {
  return (
    <Tabs defaultValue="healthcare" className="w-full">
      <TabsList className="grid w-full max-w-4xl mx-auto grid-cols-2 md:grid-cols-4">
        <TabsTrigger value="healthcare">Healthcare</TabsTrigger>
        <TabsTrigger value="trades">Skilled Trades</TabsTrigger>
        <TabsTrigger value="business">Small Business</TabsTrigger>
        <TabsTrigger value="logistics">Distribution</TabsTrigger>
      </TabsList>

      <TabsContent value="healthcare" className="mt-8">
        <Card>
          <CardContent className="p-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <img
                  src={healthcareImg}
                  alt="Healthcare virtual assistant"
                  className="rounded-lg w-full h-64 object-cover"
                />
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-semibold">Healthcare Solutions</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>HIPAA-compliant patient communication</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Automated appointment reminders and scheduling</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Insurance verification and pre-screening</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>After-hours triage and emergency routing</span>
                  </li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </TabsContent>

      <TabsContent value="trades" className="mt-8">
        <Card>
          <CardContent className="p-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <img
                  src={tradesImg}
                  alt="Trades virtual assistant"
                  className="rounded-lg w-full h-64 object-cover"
                />
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-semibold">Skilled Trades Solutions</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Emergency dispatch and priority routing</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Job estimates and parts availability checks</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Technician scheduling and route optimization</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Follow-up calls and customer satisfaction surveys</span>
                  </li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </TabsContent>

      <TabsContent value="business" className="mt-8">
        <Card>
          <CardContent className="p-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <img
                  src={businessImg}
                  alt="Small business virtual assistant"
                  className="rounded-lg w-full h-64 object-cover"
                />
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-semibold">Small Business Solutions</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>24/7 lead capture and qualification</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Order taking and inventory inquiries</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Customer support and FAQ handling</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Multi-language customer service</span>
                  </li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </TabsContent>

      <TabsContent value="logistics" className="mt-8">
        <Card>
          <CardContent className="p-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <img
                  src={logisticsImg}
                  alt="Logistics and distribution virtual assistant"
                  className="rounded-lg w-full h-64 object-cover"
                />
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-semibold">Distribution Solutions</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Real-time shipment tracking and status updates</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Automated delivery scheduling and route optimization</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Inventory management and supply chain coordination</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span>Customer notifications and delivery confirmations</span>
                  </li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
    </Tabs>
  );
};

export default IndustryTabs;
